import React, {
  FunctionComponent,
  ReactNode
} from 'react'
import { TransitionGroup } from 'react-transition-group'
import {
  CSSTransitionBox,
  popupTransitionName,
  TRANSITION_DELAY,
  TRANSITION_OUT_DELAY,
} from './TransitionBox.elements'

type Props = {
  children: ReactNode
  isOpen: boolean
  onEntered: () => void
  onExited: () => void
  pushDown?: boolean
}

export const TransitionBox: FunctionComponent<Props> = ({
  children,
  isOpen,
  onEntered,
  onExited,
  pushDown,
}: Props) => (
  <TransitionGroup component={null}>
    {isOpen && (
      <CSSTransitionBox
        appear
        classNames={popupTransitionName}
        key="modal"
        onEntered={onEntered}
        onExited={onExited}
        timeout={isOpen ? TRANSITION_DELAY : TRANSITION_OUT_DELAY}
        pushDown={pushDown}
      >
        {children}
      </CSSTransitionBox>
    )}
  </TransitionGroup>
)
